import { render } from "./NewAddCustomer.vue?vue&type=template&id=5116a7f0"
import script from "./NewAddCustomer.vue?vue&type=script&lang=js"
export * from "./NewAddCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__